<template>
  <div>
    <v-container fluid class="pa-8">
      <div class="d-flex mb-4">
        <h2 class="custom-t">{{$t("geneticsAndBreeding.animalSearchTool")}}</h2>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          right
          height="40"
          width="116"
          color="primary"
          @click="$router.push({ name: 'GeneticsList' })"
          >BACK</v-btn
        >
      </div>
      <v-card
        elevation="0"
        class="px-5"
        style="width: 100%"
        v-if="row == 'radio-1'"
      >
        <v-card-text>
          <v-radio-group v-model="row" row>
            <v-radio :label="$t('geneticsAndBreeding.seachByEPD')" value="radio-1"></v-radio>
            <v-radio :label="$t('geneticsAndBreeding.searchByIDs')" value="radio-2"></v-radio>
          </v-radio-group>
          <div class="d-flex mr-4">
            <v-row no-gutters>
              <v-col>
                <p class="black--text custom-t2">{{$t('geneticsAndBreeding.selectBreed')}}</p>
                <v-select
                  :items="breedData"
                  v-model="searchData.breed"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  class="shrink mr-2"
                  placeholder="Select Required Breed For Cattle"
                ></v-select>
              </v-col>
              <v-col>
                <p class="black--text custom-t2">{{$t('geneticsAndBreeding.selectGender')}}</p>
                <v-select
                  :items="genderData"
                  v-model="searchData.gender"
                  item-text="name"
                  item-value="roleNumber"
                  dense
                  outlined
                  class="shrink mr-2"
                  placeholder="E.g. Male"
                ></v-select>
              </v-col>
              <v-col md="2">
                <v-btn
                  class="mt-9"
                  outlined
                  right
                  height="40"
                  width="116"
                  color="primary"
                  @click="clearData()"
                  >{{$t('geneticsAndBreeding.resetFilter')}}</v-btn
                >
              </v-col>
            </v-row>
          </div>
          <div class="mt-10">
            <v-simple-table class="custom-table-1">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center custom-sty"></th>
                    <th class="text-center">
                      {{$t('geneticsAndBreeding.bw')}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t('geneticsAndBreeding.birthWeightBW')}}
                          </span>
                          {{$t('geneticsAndBreeding.CalvesText')}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center">
                      {{$t('geneticsAndBreeding.ww')}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            > {{$t('geneticsAndBreeding.weaningWeightWW')}}
                          </span>
                          {{$t('geneticsAndBreeding.weaningWeightText')}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center">
                      YW
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t('geneticsAndBreeding.yearlingWeightYW')}}
                          </span>
                          {{$t('geneticsAndBreeding.yearlingWeightText')}}</span
                        >
                      </v-tooltip>
                    </th>

                    <th class="text-center">
                      REA
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t('geneticsAndBreeding.ribEyeArea')}} </span
                          >{{$t('geneticsAndBreeding.ribEyeAreaText')}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center">
                      {{$t('geneticsAndBreeding.marbling')}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t('geneticsAndBreeding.marb')}} </span
                          >{{$t('geneticsAndBreeding.marbText')}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center">
                      {{$t('geneticsAndBreeding.fat')}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t('geneticsAndBreeding.fatThicknessFAT')}} </span
                          >{{$t('geneticsAndBreeding.fatThicknessText')}}</span
                        >
                      </v-tooltip>
                    </th>

                    <th class="text-center">
                      {{$t('geneticsAndBreeding.cw')}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t('geneticsAndBreeding.carcassWeightText')}} </span
                          ></span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center">
                      {{$t('geneticsAndBreeding.yg')}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t('geneticsAndBreeding.yeildGradeYG')}} </span
                          >{{$t('geneticsAndBreeding.yeildGradeText')}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center gray2">
                      {{$t('geneticsAndBreeding.mk')}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold">{{$t("geneticsAndBreeding.milkMK")}} </span> The
                           {{$t("geneticsAndBreeding.mkText")}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center gray2">
                      {{$t("geneticsAndBreeding.tm")}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >Total Maternal (TM):
                          </span>
                          {{$t("geneticsAndBreeding.tmText")}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center gray2">
                      {{$t("geneticsAndBreeding.ced")}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t("geneticsAndBreeding.calvingEaseDirectCED")}}
                          </span>
                          {{$t("geneticsAndBreeding.cedText")}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center gray2">
                      {{$t("geneticsAndBreeding.cem")}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t("geneticsAndBreeding.calvingEaseMaternalCEM")}} 
                          </span>
                          {{$t("geneticsAndBreeding.cemText")}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center gray2">
                      {{$t("geneticsAndBreeding.stay")}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold"
                            >{{$t('geneticsAndBreeding.stayabilitySTAY')}}
                          </span>
                          {{$t('geneticsAndBreeding.stayText')}}</span
                        >
                      </v-tooltip>
                    </th>
                    <th class="text-center gray2">
                      {{$t('geneticsAndBreeding.doc')}}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 0.750011C2.65247 0.750011 0.750011 2.6524 0.750011 5C0.750011 7.34753 2.6524 9.24999 5 9.24999C7.34753 9.24999 9.24999 7.3476 9.24999 5C9.24999 2.65247 7.3476 0.750011 5 0.750011ZM5 0C7.76197 0 10 2.23846 10 5C10 7.76197 7.76154 10 5 10C2.23803 10 0 7.76154 0 5C0 2.23803 2.23846 0 5 0Z"
                              fill="#787878"
                            />
                            <path
                              d="M5.2496 5.99953C5.2496 6.20662 5.08168 6.37453 4.87459 6.37453C4.66742 6.37453 4.49959 6.20662 4.49959 5.99953V5.81002C4.49959 5.26802 4.74619 4.98702 5.29053 4.66994C5.2768 4.67789 5.44957 4.57811 5.49486 4.55107C5.95416 4.27702 6.12459 4.03903 6.12459 3.48858C6.12459 2.86916 5.6935 2.47071 4.8746 2.47071C4.12585 2.47071 3.62452 3.0503 3.62452 3.7207C3.62452 3.92779 3.45669 4.09571 3.24952 4.09571C3.04243 4.09571 2.87451 3.92779 2.87451 3.7207C2.87451 2.6583 3.68547 1.7207 4.8746 1.7207C6.09504 1.7207 6.8746 2.44116 6.8746 3.48858C6.8746 4.33796 6.54547 4.7975 5.87925 5.19512C5.82852 5.22542 5.64989 5.32855 5.66806 5.318C5.33147 5.51404 5.24961 5.60737 5.24961 5.81003L5.2496 5.99953ZM4.84956 7.99953C4.57341 7.99953 4.34959 7.7757 4.34959 7.49955C4.34959 7.2234 4.57341 6.99949 4.84956 6.99949C5.12572 6.99949 5.34954 7.2234 5.34954 7.49955C5.34954 7.7757 5.12572 7.99953 4.84956 7.99953Z"
                              fill="#787878"
                            />
                          </svg>
                        </template>
                        <span
                          ><span class="font-weight-bold">{{$t('geneticsAndBreeding.docilityDOC')}}</span
                          >{{$t("geneticsAndBreeding.docText")}}</span
                        >
                      </v-tooltip>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{$t("geneticsAndBreeding.max")}}</td>
                    <td>
                      <input
                        v-model="searchData.bw.max"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.ww.max"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.yw.max"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.rea.max"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.marb.max"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.fat.max"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.cw.max"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.yg.max"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td class="gray2 disable-border" v-for="n in 6" :key="n">
                      <input
                        disabled
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text disable-text"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{{$t("geneticsAndBreeding.min")}}</td>
                    <td>
                      <input
                        v-model="searchData.bw.min"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.ww.min"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.yw.min"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.rea.min"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.marb.min"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.fat.min"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.cw.min"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        v-model="searchData.yg.min"
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td class="gray2" v-for="n in 6" :key="n">
                      <input
                        disabled
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text disable-text"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{{$t("geneticsAndBreeding.accuracy")}}</td>
                    <td>
                      <input
                        @keypress="restrictChars($event)"
                        v-model="searchData.bw.acc"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        @keypress="restrictChars($event)"
                        v-model="searchData.ww.acc"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        @keypress="restrictChars($event)"
                        v-model="searchData.yw.acc"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        @keypress="restrictChars($event)"
                        v-model="searchData.rea.acc"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        @keypress="restrictChars($event)"
                        v-model="searchData.marb.acc"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        @keypress="restrictChars($event)"
                        v-model="searchData.fat.acc"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        @keypress="restrictChars($event)"
                        v-model="searchData.cw.acc"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td>
                      <input
                        @keypress="restrictChars($event)"
                        v-model="searchData.yg.acc"
                        type="text"
                        class="custom-text"
                        style="background: white"
                      />
                    </td>
                    <td class="gray2" v-for="n in 6" :key="n">
                      <input
                        disabled
                        @keypress="restrictChars($event)"
                        type="text"
                        class="custom-text disable-text"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{{$t('geneticsAndBreeding.sortBy')}}</td>
                    <td>
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          key="1"
                          value="birth_weight_epd"
                          label=""
                          class="radio-bar"
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td>
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          key="2"
                          value="weaning_weight_epd"
                          label=""
                          class="radio-bar"
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td>
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          key="3"
                          value="yearling_weight_epd"
                          label=""
                          class="radio-bar"
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td>
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          key="4"
                          value="ribEyeArea_epd"
                          label=""
                          class="radio-bar"
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td>
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          key="5"
                          value="marbling_epd"
                          label=""
                          class="radio-bar"
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td>
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          key="6"
                          value="fatThickness_epd"
                          label=""
                          class="radio-bar"
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td>
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          key="7"
                          value="carcass_weight_epd"
                          label=""
                          class="radio-bar"
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td>
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          key="8"
                          value="yield_grade_epd"
                          label=""
                          class="radio-bar"
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td class="gray2">
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          disabled
                          key="9"
                          value="9"
                          label=""
                          class=""
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td class="gray2">
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          disabled
                          key="10"
                          value="10"
                          label=""
                          class=""
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td class="gray2">
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          disabled
                          key="11"
                          value="11"
                          label=""
                          class=""
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td class="gray2">
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          disabled
                          key="12"
                          value="12"
                          label=""
                          class=""
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td class="gray2">
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          disabled
                          key="13"
                          value="13"
                          label=""
                          class=""
                        ></v-radio>
                      </v-radio-group>
                    </td>
                    <td class="gray2">
                      <v-radio-group v-model="radioooGroup">
                        <v-radio
                          disabled
                          key="14"
                          value="14"
                          label=""
                          class=""
                        ></v-radio>
                      </v-radio-group>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="d-flex justify-space-between align-center mt-5">
            <v-alert v-model="alert" text outlined class="mr-5">
              <span class="red--text font-weight-bold">Note: </span>
              <span class="black--text"
                >{{$t('geneticsAndBreeding.notes')}}</span
              >
            </v-alert>
            <v-btn
              class="primarys"
              width="146"
              color="primary"
              @click="openDialog()"
              >{{$t('geneticsAndBreeding.search')}}</v-btn
            >
          </div>
          <!-- <div style="margin-top: 60px" class="registration-btn bottom-btn">
                        <v-btn class="primarys"  width="146" color="primary" @click="openDialog()">SEARCH</v-btn>
                    </div>        -->
        </v-card-text>
      </v-card>
      <v-card
        elevation="0"
        class="px-5"
        style="flex: 1"
        v-if="row == 'radio-2'"
      >
        <v-card-text>
          <v-radio-group v-model="row" row>
            <v-radio :label="$t('geneticsAndBreeding.seachByEPD')" value="radio-1"></v-radio>
            <v-radio :label="$t('geneticsAndBreeding.searchByIDs')" value="radio-2"></v-radio>
          </v-radio-group>
          <v-row>
            <v-col>
              <p class="black--text custom-t2">{{$t('geneticsAndBreeding.selectGender')}}</p>
              <v-select
                :items="genderData"
                v-model="searchTagData.gender"
                item-text="name"
                item-value="id"
                min-width="400"
                dense
                outlined
                class=""
                placeholder="E.g. Male"
              ></v-select>
              <h3 class="mt-7 mb-2 custom-t3">{{$t('geneticsAndBreeding.searchBy')}} :</h3>
              <v-radio-group class="ml-3" v-model="radioGroup">
                <v-layout row wrap>
                  <v-flex column>
                    <p class="custom-t4">{{$t('geneticsAndBreeding.reg')}}</p>
                    <v-radio key="1" value="regNumber"> </v-radio>
                  </v-flex>
                  <v-flex column>
                    <p class="custom-t4">{{$t('geneticsAndBreeding.tattoo')}}</p>
                    <v-radio key="2" value="tattoo"> </v-radio>
                  </v-flex>
                  <v-flex column>
                    <p class="custom-t4">{{$t('geneticsAndBreeding.name')}}</p>
                    <v-radio key="3" value="name"> </v-radio>
                  </v-flex>
                  <v-flex column>
                    <p class="custom-t4">{{$t('geneticsAndBreeding.tag')}}#</p>
                    <v-radio key="4" value="tag"> </v-radio>
                  </v-flex>
                </v-layout>
              </v-radio-group>
              <h3 class="mt-3 mb-3 custom-t3">{{$t("geneticsAndBreeding.searchValue")}}</h3>
              <v-text-field
                v-model="searchTagData.search"
                outlined
                height="5px"
                placeholder="Type here"
                dense
                class="shrink"
              ></v-text-field>
              <div class="registration-btn bottom-btn">
                <v-btn
                  class="primarys"
                  :disabled="searchTagData.search.length < 1"
                  width="146"
                  color="primary"
                  @click="openDialog1()"
                  >{{$t("geneticsAndBreeding.search")}}</v-btn
                >
              </div>
            </v-col>
            <v-spacer> </v-spacer>
            <v-col>
              <v-img
                style="border-radius: 10px"
                width="500"
                height="auto"
                src="/img/epd_cow.png"
              ></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog
        v-model="dialog"
        max-width="600"
        height="400"
        @click:outside="dialog = false"
      >
        <v-card>
          <v-toolbar color="secondary" class="white--text" flat>
            <v-toolbar-title class="font-weight-bold"
              >{{$t("geneticsAndBreeding.searching")}}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="unset()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="py-5">
            <v-img
              style="margin: auto"
              width="150"
              src="/img/loading.gif"
            ></v-img>
            <h2 class="text-center mt-5">{{$t("geneticsAndBreeding.fetchingResult")}}</h2>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="emptyData"
        max-width="600"
        height="400"
        @click:outside="emptyData = false"
      >
        <v-card>
          <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold"
              >{{$t("geneticsAndBreeding.searchResult")}}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="unset()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div class="alignCenter">
            <v-img
              style="margin-left: 240px; margin-top: 60px"
              width="100"
              src="/img/noData.svg"
            ></v-img>
            <h2 class="mt-6 pb-16">{{$t("geneticsAndBreeding.animalMsg")}}</h2>
            <v-btn
              outlined
              right
              height="40"
              width="116"
              color="primary"
              @click="unset()"
              >{{$t("geneticsAndBreeding.cancel")}}</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";

export default {
  mounted() {
    // this.animalDropDownBreed();
    // this.animalDropDownGender();
  },
  methods: {
    async openDialog() {
      if (this.searchData.bw.min < -5) {
        this.$notify({
          title: "Error",
          text: "Birth weight cannot be less than -5",
          type: "error",
        });
        return;
      }
      if (this.searchData.ww.min < 0) {
        this.$notify({
          title: "Error",
          text: "Weaning weight cannot be less than 0",
          type: "error",
        });
        return;
      }
      if (this.searchData.yw.min < 0) {
        this.$notify({
          title: "Error",
          text: "Yearling weight cannot be less than 0",
          type: "error",
        });
        return;
      }
      // if(this.searchData.bw.max > 6){
      //     this.$notify({
      //         title: 'Error',
      //         text: "Birth weight cannot be greater than 6",
      //         type: 'error'
      //     });
      //     return;
      // }
      if (!this.searchData.ww.max != null && this.searchData.ww.max > 150) {
        this.$notify({
          title: "Error",
          text: "Weaning weight cannot be greater than 150",
          type: "error",
        });
        return;
      }
      if (!this.searchData.yw.max != null && this.searchData.yw.max > 200) {
        this.$notify({
          title: "Error",
          text: "Yearling weight cannot be greater than 200",
          type: "error",
        });
        return;
      }
      // console.log(this.searchData.bw.max, this.searchData.bw.min, 'log')
      // console.log(this.searchData.bw.max < this.searchData.bw.min, 'log')
      if (
        this.searchData.bw.max != null &&
        Number(this.searchData.bw.max) < Number(this.searchData.bw.min)
      ) {
        this.$notify({
          title: "Error",
          text: "Birth weight maximum value cannot be less than Birth weight minimum",
          type: "error",
        });
        return;
      }
      if (
        this.searchData.ww.max != null &&
        Number(this.searchData.ww.max) < Number(this.searchData.ww.min)
      ) {
        this.$notify({
          title: "Error",
          text: "Weaning weight maximum value cannot be less than Weaning weight minimum",
          type: "error",
        });
        return;
      }
      if (
        this.searchData.yw.max != null &&
        Number(this.searchData.yw.max) < Number(this.searchData.yw.min)
      ) {
        this.$notify({
          title: "Error",
          text: "Yearling weight maximum value cannot be less than Yearling weight minimum",
          type: "error",
        });
        return;
      }
      this.dialog = true;
      this.searchData.sortCol = this.radioooGroup;
      this.searchData.sortOrder = this.sortOrder;
      localStorage.removeItem("searchTagData");
      localStorage.setItem("searchData", JSON.stringify(this.searchData));
      localStorage.setItem(
        "sortGeneticList",
        JSON.stringify({
          sort: { sortBy: this.radioooGroup, sortOrder: this.sortOrder },
        })
      );
      console.log("search data", this.searchData);

      this.dialog = false;
      this.$router.push({
        name: "GeneticSearchList",
        params: { items: this.searchData },
        props: true,
      });

      // await AnimalService.animalGeneticsSearch(this.options,this.searchData)
      //     .then((res) => {
      //         if(res.data.rows.length <= 0){
      //             this.emptyData = true
      //         }
      //         this.dataCheck = res.data.rows
      //         if(res.data.rows.length > 0){
      //             this.dialog = false
      //             this.$router.push({ name: 'GeneticSearchList', params:{items: this.searchData}, props:true})

      //         }else{
      //             this.dialog = false
      //             this.emptyData = true
      //         }
      //     }).catch(err => {
      //         this.dialog = false
      //         console.log(err)
      //     })
      //    this.dialog = false
    },
    async openDialog1() {
      this.dialog = true;
      this.searchTagData.searchCol = this.radioGroup;
      localStorage.setItem("searchTagData", JSON.stringify(this.searchTagData));
      localStorage.removeItem("searchData");
      AnimalService.animalGeneticsSearchByReg(this.options, this.searchTagData);
      if (this.searchTagData) {
        // this.startLoading();
        this.loading = true;
        const animals = await AnimalService.animalGeneticsSearchByReg(
          this.options,
          this.searchTagData
        );
        console.log(animals);
        if (animals?.data) {
          const animalResponse = animals.data?.geneticSearchToolById;
          this.dataCheck = animalResponse.rows;
          if (this.dataCheck.length != 0) {
            this.$router.push({
              name: "GeneticSearchList",
              params: { itemss: this.searchTagData },
              props: true,
            });
            this.dialog = false;
          } else {
            this.dialog = false;
            this.emptyData = true;
          }
        } else if (animals?.errors) {
          this.dialog = false;
          this.emptyData = true;
          console.log(animals?.errors);
        }
      }
    },
    unset() {
      this.dialog = false;
      this.emptyData = false;
      localStorage.removeItem("searchTagData");
      localStorage.removeItem("searchData");
    },
    restrictChars: function ($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else if ($event.charCode === 45 || $event.charCode === 46) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    // animalDropDownBreed(){
    //     AnimalService.animalDropDownBreed()
    //     .then((res) => {
    //         this.breedData = res.data;
    //     })
    //     .catch((err) => {
    //         console.log(err)
    //     })
    // },
    // animalDropDownGender(){
    //     AnimalService.animalDropDownGender()
    //     .then((res) => {
    //         this.genderData = res.data;
    //         this.searchTagData.gender = this.genderData[0]
    //         this.searchData.gender = this.genderData[0]
    //     })
    //     .catch((err) => {
    //         console.log(err)
    //     })
    // },
    clearData() {
      this.searchData = {
        breed: "",
        gender: "",
      };
    },
  },
  data() {
    return {
      alert: true,
      options: { itemsPerPage: 10, page: 1 },
      dataCheck: [],
      emptyData: false,
      breedData: [
        "Brahman",
        "Bonsmara",
        "Simmental",
        "Holstein-Friesian",
        "Naganda",
        "Nkedi",
        "Bonsmara",
        "Kyoga",
        "Nyoro",
        "Kigezi",
        "Mix Breed",
        "Other",
      ],
      genderData: ["Male", "Female"],
      searchTagData: {
        gender: "",
        searchCol: "",
        search: "",
      },
      searchData: {
        gender: "",
        breed: "",
        bw: {
          min: null,
          max: null,
          acc: null,
        },
        ww: {
          min: null,
          max: null,
          acc: null,
        },
        yw: {
          min: null,
          max: null,
          acc: null,
        },
        rea: {
          min: null,
          max: null,
          acc: null,
        },
        marb: {
          min: null,
          max: null,
          acc: null,
        },
        fat: {
          min: null,
          max: null,
          acc: null,
        },
        cw: {
          min: null,
          max: null,
          acc: null,
        },
        yg: {
          min: null,
          max: null,
          acc: null,
        },
      },
      dialog: false,
      radioGroup: "regNumber",
      radiooGroup: "15",
      radioooGroup: "",
      row: "radio-1",
      sortOrder: "ASC",
    };
  },
};
</script>
<style lang="scss" scoped>
.alignCenter {
  text-align: center;
  padding-bottom: 40px;
}
.flex,
.child-flex > * {
  flex: 0.2 1 auto;
  max-width: 100%;
}
.registration-btn {
  display: flex;
  align-items: center;
}
.registration-btn.bottom-btn {
  margin: 30px 22px 0px 0px;
  justify-content: flex-end;
  width: 100%;
}
.v-application .pa-2 {
  padding-left: 4px !important;
  border: 0.913628px solid rgba(0, 0, 0, 0.2);
}

.new {
  padding: 8px 8px 8px 8px !important;
  border: 0.913628px solid rgba(0, 0, 0, 0.2);
  min-width: 61px;
  color: rgba(0, 0, 0, 0);
}
.new1 {
  padding: 30px 8px 27px 8px !important;
  border: 0.913628px solid rgba(0, 0, 0, 0.2);
  min-width: 61px;
  color: rgba(0, 0, 0, 0);
  font-size: 12px;
}
::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-top: 0px;
  margin-bottom: 8px;
  display: none;
}
::v-deep .v-input--selection-controls__ripple {
  border-radius: 50%;
  cursor: pointer;
  height: 34px;
  position: absolute;
  transition: inherit;
  width: 0px;
  left: -12px;
  top: calc(50% - 24px);
  margin: 7px;
}

.fon {
  font-size: 10px;
}
::v-deep .textCenter input#input-105 {
  text-align: center;
}

::v-deep .v-select.v-text-field input {
  font-size: 12px;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  pointer-events: none;
  position: relative;
}

.custom-table-1 {
  margin-top: 10px;
  border-collapse: collapse;
}
.custom-table-1 th {
  border: 1px solid #ccc;
}
input.custom-text {
  width: 26px;
  height: 26px;
  background: #f5f5f5;
  border: 1px solid #c4c4c4;
  border-radius: 3px;
  text-align: center;
}
.custom-table-1 th {
  width: 0px;
}
.custom-table-1 th,
td {
  font-size: 11px !important;
  color: #000 !important;
  border-right: 1px solid #ccc !important;
  border-left: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
  text-align: center;
  padding: 0px 0px !important;
  border-spacing: 0px;
}
td.gray2 {
  border-right: 1px solid white !important;
  border-left: 1px solid white !important;
  border-bottom: 1px solid white !important;
}
th.gray2 {
  border-right: 1px solid white !important;
  border-left: 1px solid white !important;
  border-bottom: 1px solid white !important;
}
.custom-text:focus-visible {
  outline: none !important;
}
.v-input--selection-controls {
  margin-top: 8px;
  padding-top: 4px;
  margin-left: 16px;
}
::v-deep .v-messages.theme--light {
  display: none;
}
.custom-t {
  color: #1e1e1e;
  font-family: pop_Bold;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
}
.custom-t1 {
  color: #1e1e1e;
  font-family: pop_Bold;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
}
.custom-t2 {
  color: #1e1e1e;
  font-family: pop_SemiBold;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.custom-t3 {
  color: #1e1e1e;
  font-family: pop_Bold;
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
}
.custom-t4 {
  color: #1e1e1e;
  font-family: pop_SemiBold;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}
.primarys {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  font-family: pop_Bold;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.custom-t5 {
  color: #000000;
  font-family: pop_SemiBold;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  padding-left: 170px;
}

.custom-sty {
  min-width: 45px !important;
}

.custom-table-1 .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 4px;
  margin-left: 0px;
}
::v-deep .custom-table-1 .v-input--selection-controls__input {
  margin-right: 0px;
}
.custom-table-1 .v-radio.theme--light {
  justify-content: center;
}
::v-deep .v-input__slot {
  margin-bottom: 0px !important;
}
::v-deep .custom-new .v-card__text {
  padding: 16px 0px !important;
}

::v-deep .v-input--selection-controls .v-radio > .v-label {
  align-items: center;
  display: inline-flex;
  flex: 1 1 auto;
  height: auto;
  font-weight: 700;
  font-size: 18px;
  line-height: 32px;
  color: #1e1e1e;
  font-family: "Poppins";
}
.v-input.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row {
  margin-left: 0px;
  margin-bottom: 20px;
}

::v-deep
  .primary--text.theme--light.v-input.v-input--dense.v-input--is-focused.v-text-field.v-text-field--enclosed.v-text-field--is-booted.v-text-field--outlined.v-text-field--placeholder {
  min-width: 400px;
}

::v-deep
  .v-input.v-input--dense.theme--light.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-text-field--placeholder.v-select {
  min-width: 400px;
}

::v-deep
  .v-input.shrink.mr-2.v-input--dense.theme--light.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-text-field--placeholder.v-select {
  min-width: 200px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0.4 1 auto;
  margin-top: 12px;
  margin-bottom: 12px;
}
::v-deep .radio-bar .v-icon {
  background: white !important;
  border-radius: 50%;
  width: 24px;
  height: 18px;
}
.disable-text {
  background: #e0e0e0 !important;
}
.disable-border {
  // border-left: 1px solid white !important;
  padding: 5px;
}
</style>
